import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Subject, Observable } from 'rxjs';
import {SystemApp} from "../constans/SystemConfigurations";
import {ApiUrl} from "../shared/models/apiurl.models";

@Injectable({
    providedIn: 'root',
})
export class AdminWebsocketService {
    private socket$: WebSocketSubject<any> | null = null;
    private notification$ = new Subject<string>();
    constructor(private apiUrl: ApiUrl) {
    }
    connect(): void {
        console.log(`${SystemApp.web_socket}admin/dashboard/?token=${this.apiUrl.getJWTTokenKey()}`)
        if (this.socket$) return;
        this.socket$ = webSocket(`${SystemApp.web_socket}admin/dashboard/?token=${this.apiUrl.getJWTTokenKey()}`);

        this.socket$.subscribe({
            next: (msg) => {
                if (msg.type == 'online_users') {
                    this.notification$.next(msg);
                }
            },
            error: (err) => console.    error('Admin WS error', err),
            complete: () => console.warn('Admin socket closed'),
        });
    }

    getNotifications(): Observable<string> {
        return this.notification$.asObservable();
    }

    // disconnect(): void {
    //     this.socket$?.complete();
    //     this.socket$ = null;
    // }
}
